<script>
  export default {
    name: '',
    props: {
      color: {
        type: String,
        default: '#E60010'
      }
    },
    computed: {
      styles() {
        return {
          fill: this.color
        }
      }
    }
  }
</script>

<template lang="pug">
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <path fill-rule="evenodd" d="M10,0 C15.5228475,0 20,3.13400675 20,7 C20,10.8659932 15.5228475,14 10,14 C9.69192279,14 9.38709944,13.990248 9.08612556,13.971161 L3,18.1104404 L4.08305372,12.6437146 C1.60698152,11.3695569 0,9.31614417 0,7 C0,3.13400675 4.4771525,0 10,0 Z" transform="translate(2 4)"/>
  </svg>
</template>

<style lang="scss" scope>
svg {
  display: block;
}
</style>
